import {Component, OnInit} from '@angular/core';
import {MetaTitle} from '../../../../decorator/meta-title';
import {OfferService} from '../../../../services/offer/offer.service';
import {Offer} from '../../../../models/offer';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {CurrencyPipe} from '../../../../pipes/currency/currency.pipe';
import {Paginator} from '../../../../tools/pagination/paginator';
import {PaginatorComponent} from '../../../layout/paginator/paginator.component';
import {PartnerOffer} from '../../../../models/partner-offer';
import {PartnerOfferService} from '../../../../services/partner-offer/partner-offer.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {Partner} from '../../../../models/partner';
import {forkJoin} from 'rxjs';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {ImageService} from '../../../../services/image/image.service';
import {RouterLink} from '@angular/router';
import {LoaderService} from '../../../../services/loader/loader.service';
import {DropdownSelectComponent} from '../../../layout/dropdown-select/dropdown-select.component';
import {DropdownSelectOptionComponent} from '../../../layout/dropdown-select-option/dropdown-select-option.component';
import {Country} from '../../../../models/country';
import {ConstantList} from '../../../../models/constant-list';

@Component({
  selector: 'app-offer-list',
  imports: [
    NgForOf,
    TranslatePipe,
    CurrencyPipe,
    NgClass,
    PaginatorComponent,
    ReactiveFormsModule,
    NgIf,
    RouterLink,
    DropdownSelectComponent,
    DropdownSelectOptionComponent
  ],
  templateUrl: './offer-list.component.html',
  styleUrl: './offer-list.component.scss'
})
@MetaTitle('Offer list')
export class OfferListComponent implements OnInit {

  filters = new FormGroup({
    name: new FormControl(''),
    conversionType: new FormControl(''),
    verticals: new FormControl([]),
    countries: new FormControl([]),
    requireApproval: new FormControl('')
  });

  connectedUser: Partner | null = null;
  offers: Offer[] = [];
  expandedCountries: { [index: number]: boolean } = {};
  partnerOffers: PartnerOffer[] = [];

  countries: Country[] = [];
  verticalList: ConstantList[] = [];
  conversionTypeList: string[] = [];

  paginator: Paginator = new Paginator();

  constructor(
    protected imageService: ImageService,
    private auth: AuthService,
    private loader: LoaderService,
    private offerService: OfferService,
    private partnerOfferService: PartnerOfferService,
  ) {
  }

  ngOnInit(): void {
    this.loader.startLoading();

    forkJoin([
      this.auth.getConnectedUser(),
      this.auth.getAsyncConfig(),
    ]).subscribe(([connectedUser, config]) => {
      if (connectedUser && connectedUser.id) {
        this.connectedUser = connectedUser;
        this.countries = config?.countries ?? [];
        this.conversionTypeList = config?.data?.conversionTypeList;
        this.verticalList = config?.data?.verticalList.map((vertical: any) => new ConstantList().deserialize(vertical));

        this.partnerOfferService.findAll().subscribe((partnerOffers: PartnerOffer[]) => {
          this.partnerOffers = partnerOffers;

          this.fetchAll();

          this.loader.stopLoading();
        });
      }
    });
  }

  fetchAll(): void {
    const data: any = {groups: 'product,goals,goal,goalTypes,goalType', sort: 'name'};
    if (this.connectedUser) {
      data['partnerId'] = this.connectedUser.id;
    }

    for (const [index, value] of Object.entries(this.filters.value)) {
      if ((value !== '' && !Array.isArray(value)) || value.length) {
        data[index] = value;
      }
    }

    this.offerService.findAll(data, this.paginator).subscribe((offers: Offer[]) => {
      this.offers = offers;
    });
  }

  getVerticalName(verticalId: number): string {
    const vertical = this.verticalList.find((vertical: ConstantList) => Number(vertical.id) === Number(verticalId));

    return 'vertical.' + (vertical?.identifier ?? '');
  }

  getOfferStatus(offer: Offer): string {
    const partnerOffer = this.partnerOffers.find((data: PartnerOffer) => data.offer?.id === offer.id);
    if (partnerOffer) {
      return partnerOffer.status;
    }

    return offer.requireApproval && !this.connectedUser?.allOffersAccess ? 'apply_to_run' : 'public';
  }

  getOfferStatusClass(offer: Offer): string {
    const status = this.getOfferStatus(offer);

    switch (status) {
      case 'pending':
        return 'bg-warning';
      case 'apply_to_run':
        return 'bg-primary';
      case 'active':
        return 'bg-success';
      default:
        return 'bg-dark';
    }
  }

}
